module.exports = __webpack_public_path__ + "media/images/pic/hero/meat-ceceeebc8ad944aee8b9b45287962c62.webp";